import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import PlayerService from "services/playerService"
import { getProfile } from "./clubSlice"

// Async thunks for login and logout
export const getAll = createAsyncThunk(
  "club/getAll",
  async (
    { page = 1, age = null, position = null, level = null, searchValue = null },
    { rejectWithValue }
  ) => {
    try {
      const response = await PlayerService.getAll(
        page,
        age,
        position,
        level,
        searchValue
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const getPlayById = createAsyncThunk(
  "player/getByID",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PlayerService.getPlayerById(id)
      console.log(response);
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

// Initial state
const initialState = {
  players: [],
  player: null,
  loading: false,
  error: null,
  totalItems: 0,
  currentPage: 1,
  totalPages: 0,
  //loading
  fetchLoading: false,
  getProfileLoading: false,
}

// Slice
const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
  },
  extraReducers: (builder) => {
    // getPlayers
    builder
      .addCase(getAll.pending, (state) => {
        state.fetchLoading = true
        state.error = null
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.fetchLoading = false
        state.players = action.payload.validatedPlayers
        state.totalItems = action.payload.totalPlayers
        state.totalPages = action.payload.totalPages
      })
      .addCase(getAll.rejected, (state, action) => {
        state.players = []
        state.fetchLoading = false
        state.error = action.payload
      })

      .addCase(getPlayById.pending, (state) => {
        state.getProfileLoading = true
        state.error = null
      })
      .addCase(getPlayById.fulfilled, (state, action) => {
        state.getProfileLoading = false
        state.player = action.payload
      })
      .addCase(getPlayById.rejected, (state, action) => {
        state.getProfileLoading = false
        state.error = action.payload
      })
  },
})
export const { setCurrentPage } = playerSlice.actions
export default playerSlice.reducer
